import { Controller } from 'stimulus'
import debounce from 'lodash/debounce'
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = {
    searchUrl: String
  }
  static targets = ['results', 'input', 'preview', 'search']

  initialize() {
    this.search = debounce(this.search, 500).bind(this)
  }

  async search(event) {
    const response = await get(this.searchUrlValue, {
      query: { q: event.target.value },
      responseKind: 'js'
    })
    if (response.ok) {
      const body = await response.text
      this.resultsTarget.innerHTML = body
    }
  }

  select(event) {
    this.resultsTarget.innerHTML = ''
    this.searchTarget.value = ''
    this.previewTarget.src = event.currentTarget.src
    this.inputTarget.value = event.currentTarget.dataset.imageUrl

    // this.inputTarget.form.requestSubmit()

    // this.inputTarget.value = ''
  }
}
